// Match the Airwallex host exactly. A substring check like `origin.includes("airwallex.com")`
// also accepts hostile origins such as https://airwallex.com.evil.com and https://evil-airwallex.com,
// which could then post messages into our card-detail / PIN iframes (CodeQL: incomplete URL sanitization).
export const isAirwallexOrigin = (origin: unknown): boolean => {
  if (typeof origin !== "string") return false
  try {
    const { hostname } = new URL(origin)
    return hostname === "airwallex.com" || hostname.endsWith(".airwallex.com")
  } catch {
    return false
  }
}
